jQuery(document).on('nfFormReady', function (e, layoutView) {
    jQuery(
        "input[type='text'], input[type='password'], input[type='date'], input[type='datetime'], input[type='datetime-local'], input[type='month'], input[type='week'], input[type='email'], input[type='number'], input[type='search'], input[type='tel'], input[type='time'], input[type='url'], textarea"
    ).on('focus', function () {
        jQuery(this).closest('.field-wrap').addClass('field-wrap--state-focus')
    })

    jQuery(
        "input[type='text'], input[type='password'], input[type='date'], input[type='datetime'], input[type='datetime-local'], input[type='month'], input[type='week'], input[type='email'], input[type='number'], input[type='search'], input[type='tel'], input[type='time'], input[type='url'], textarea"
    ).on('blur', function () {
        var inputValue = jQuery(this).val()
        if (inputValue == '') {
            jQuery(this).removeClass('filled')
            jQuery(this).closest('.field-wrap').removeClass('field-wrap--state-focus')
        } else {
            jQuery(this).addClass('filled')
        }
    })
})

window.addEventListener('message', (event) => {
  if (
    event.data.type === 'hsFormCallback' &&
    event.data.eventName === 'onFormReady'
  ) {

    initFormWatch(event)

  }
});

const initFormWatch = (event) => {

    const hubspotForms = document.querySelectorAll('.hs-form')
    for (const form of hubspotForms) {

        const formInputs = form.querySelectorAll("input[type='text'], input[type='password'], input[type='date'], input[type='datetime'], input[type='datetime-local'], input[type='month'], input[type='week'], input[type='email'], input[type='number'], input[type='search'], input[type='tel'], input[type='time'], input[type='url'], textarea"),
              formSelects = form.querySelectorAll("select")

        for (const input of formInputs) {
            let parentEl = input.closest('.hs-form-field')

            if(input.value !== '') {
                parentEl.classList.add('hs-form-field--state-focus');
            }

            input.addEventListener('focus', function () {
                parentEl.classList.add('hs-form-field--state-focus');
            })

            input.addEventListener('blur', function () {
                if(input.value == '') {
                    parentEl.classList.remove('hs-form-field--state-focus')
                }
            })
        }

        for (const select of formSelects) {
            let parentEl = select.closest('.hs-form-field')

            if(select.value !== '') {
                parentEl.classList.add('hs-form-field--state-focus');
            }


            select.selectedIndex = -1;

            select.addEventListener('focus', function () {
                parentEl.classList.add('hs-form-field--state-focus');
            })

            select.addEventListener('blur', function () {
                if(select.value == '') {
                    parentEl.classList.remove('hs-form-field--state-focus')
                }

                console.log(select.value)
            })
        }

    }
}
